'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierConfig = exports.themePropTypes = exports.styles = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n      background: inherit;\n      pointer-events: none;\n    '], ['\n      background: inherit;\n      pointer-events: none;\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border: none;\n  color: ', ';\n  font-size: ', ';\n  line-height: ', ';\n  outline: none;\n  padding: 0;\n  width: 100%;\n\n  &::placeholder {\n    color: ', ';\n  }\n'], ['\n  border: none;\n  color: ', ';\n  font-size: ', ';\n  line-height: ', ';\n  outline: none;\n  padding: 0;\n  width: 100%;\n\n  &::placeholder {\n    color: ', ';\n  }\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _modifiers = require('../../modifiers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var modifierConfig = _extends({}, _modifiers.spacing, {
  readOnly: function readOnly() {
    return {
      styles: (0, _styledComponents.css)(_templateObject)
    };
  }
});

var styles = exports.styles = function styles(_ref) {
  var theme = _ref.theme;
  return (0, _styledComponents.css)(_templateObject2, theme.colors.base.text, (0, _decisivUiUtils.px2rem)(12), (0, _decisivUiUtils.px2rem)(20), theme.colors.base.chrome300);
};

var themePropTypes = exports.themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome300: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.modifierConfig = modifierConfig;
exports.default = (0, _decisivUiUtils.buildStyledComponent)('TextField', _styledComponents2.default.input, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/elements/TextField/index.js
// module id = 717
// module chunks = 2